import {
  FETCH_BIRTHDAY_REQUEST,
  FETCH_BIRTHDAY_SUCCESS,
  FETCH_BIRTHDAY_FAILURE,
} from "../constants/EventsConstants";

const initialState = {
  birthdayItems: [],
  loading: false,
};

const eventsReducer = (state = initialState, action) => {
  switch (action.type) {
    case FETCH_BIRTHDAY_REQUEST:
      return { ...state, loading: true };
    case FETCH_BIRTHDAY_SUCCESS:
      return { ...state, birthdayItems: action.payload, loading: false };
    case FETCH_BIRTHDAY_FAILURE:
      return { ...state, loading: false };
    default:
      return state;
  }
};

export default eventsReducer;
